// react
import * as React from "react";
// material
import List from "material-ui/List/List";
import ListItem from "material-ui/List/ListItem";
import ActionCheckCircle from "material-ui/svg-icons/action/check-circle";
// global
import l10n = require("diy/util/l10n");
// local
import {StepData} from "../StepData";

const SIDEBAR_WIDTH_TABLET = 214;
const SIDEBAR_WIDTH_SCREEN = 224;

interface SidebarProps {
    steps: StepData[];
    liteVersion: boolean;
    activeStep?: StepData;
    onStepSelect?: (step: StepData) => any;
}

export const computeSidebarWidth = (liteVersion = false) => {
    return liteVersion ? SIDEBAR_WIDTH_TABLET : SIDEBAR_WIDTH_SCREEN;
};

export class Sidebar extends React.Component<SidebarProps, {}> {
    render() {
        return (
            <div className="sidebar" style={this.getRootStyle(this.props.liteVersion) }>
                <List style={this.getListStyle() }>
                    {this.props.steps.map(step => this.renderStep(step)) }
                </List>
            </div>
        );
    };

    private renderStep(step: StepData) {
        const stepLabel = l10n.getString('onboardingGuide.step.' + step.id + '.title');
        if (step.hidden) {
            return null;
        }
        return (
            <ListItem
                data-test-id={`menu-step-${step.id}`}
                key={step.id}
                primaryText={stepLabel}
                style={this.getItemStyle(step) }
                innerDivStyle={this.getItemInnerStyle()}
                leftIcon={step.completed ?
                    <ActionCheckCircle color="#019e28" style={this.getItemIconStyle()} />
                    : null}
                onClick={() => this.onItemClick(step) }
                ></ListItem>
        );
    };

    private onItemClick(step: StepData) {
        this.props.onStepSelect(step);
    };

    private getItemIconStyle() {
        return {
            left: 0,
        };
    };

    private getRootStyle(liteVersion: boolean) {
        return {
            width: computeSidebarWidth(liteVersion) + "px",
            backgroundColor: "rgba(236, 235, 235, 1)",
            height: "534px",
            flex: "1 0 auto"
        };
    };

    private getListStyle() {
        return {
            backgroundColor: 'transparent',
            paddingTop: 0,
            paddingBottom: 0,
            overflowX: "hidden",
            height: "inherit"
        };
    };

    private getItemInnerStyle() {
        return {
            paddingLeft: "42px",
        };
    };

    private getItemStyle(step: StepData) {
        let activeStyles = {
            color: "rgba(22, 25, 29, 1)",
            backgroundColor: "rgba(206, 208, 214, 1)"
        };

        let style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: "rgba(61, 73, 89, 1)"
        };

        if (step === this.props.activeStep) {
            Object.assign(style, activeStyles);
        }

        return style;
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/Sidebar.tsx
 **/